export default __webpack_public_path__ + "static/media/html_pricing_community.6ae516a4.md";